<template>
  <Page>
    <div class="topimg"></div>
    <div class="con">
      <div class="title-box">
          <!-- <h4 class="fs16 mb25">2019-11-11</h4> -->
          <h2 class="fs24">{{detail.title}}</h2>
      </div>
      <div class="html-con" v-html="detail.description">
       
      </div>
    </div>
  </Page>
</template>

<script>
import Page  from '@/components/page.vue'



export default {
  name: '',
  components:{Page},
  data(){
    return {
    }
  },
  created(){
    !this.detail.title&&this.$store.dispatch('dynamic/getDetail')
  },
  computed:{
    detail(){return this.$store.state.dynamic.detail}
  },
  methods:{
  
  }
}
</script>

<style scoped>
.con{padding:4.47vw 5.26vw;}
.con .html-con{width:950px;}
.title-box{padding-bottom:1.47vw; border-bottom:1px solid #e6e6e6;}
.title-box h4{color:#868686; font-weight: normal;}
.title-box h2{color:#222;}
.html-con{padding:2vw 0;}
@media (max-width:991px){
.con{padding:6vw 1.5vw;}
.con .html-con{ width:97vw;}
}
</style>

<style>
.con .html-con img{max-width: 950px; width:auto!important; height:auto!important;}

@media (max-width:991px){
  .con .html-con img{max-width: 97vw; width:auto!important; height:auto!important;}
}
</style>